import { GetterTree } from 'vuex';
import { RootState, dailyLottoState } from '@/types/store';

export const getters: GetterTree<dailyLottoState, RootState> = {
    allDraws: (state) => state.draws,
    allCartDaily: (state) => state.cartDaily,
};

export default getters;
